import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import SeasonSelect from "../SeasonSelect";
import {useTranslation} from "react-i18next";

export const useToolbar = ({availableSeasons}) => {
    const sortedSeason = availableSeasons.sort((a, b) => b - a);

    const [seasonFrom, setSeasonFrom] = useState(sortedSeason?.[0] ?? null)
    const [seasonTo, setSeasonTo] = useState(null);

    useEffect(() => {
        setSeasonFrom(sortedSeason?.[0] ?? null);
        setSeasonTo(null);
    }, [availableSeasons]);

    return {
        seasonFrom,
        setSeasonFrom,
        seasonTo,
        setSeasonTo,
        availableSeasons,
    }
}

const Toolbar = (props) => {
    const {t} = useTranslation("graphs");
    const {
        seasonFrom,
        setSeasonFrom,
        seasonTo,
        setSeasonTo,
        availableSeasons,
    } = props;

    return <Grid container sx={{py: 4}} columnSpacing={2}>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={seasonFrom}
                          setSelectedSeason={setSeasonFrom}
                          sx={{minWidth: "9rem"}}
                          label={t("toolbar.seasonFrom")}
                          availableSeasons={availableSeasons}
                          fullWidth
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={seasonTo}
                          setSelectedSeason={setSeasonTo}
                          sx={{minWidth: "9rem"}}
                          label={t("toolbar.seasonTo")}
                          availableSeasons={availableSeasons}
                          fullWidth
                          optionsFrom={seasonFrom}
            />
        </Grid>
    </Grid>
}

export default Toolbar;